export default __webpack_public_path__ + "static/media/6.8d281152.png";